
import { defineComponent } from 'vue';
import { mapState } from 'pinia';
import { useStore } from '@/plugins/store/index';
import Modal from '@/components/ui/Modal.vue';
import GenericTable from '@/components/tables/GenericTable.vue';
import CourseThemeSessionsModal from '@/views/Courses/CourseThemeSessionsModal.vue';
import { Session, Theme } from '@/types';

export default defineComponent({
    components: { Modal, GenericTable, CourseThemeSessionsModal },
    props: {
        selectedCourse: {
            type: Object as () => {
                id: string;
                title: string;
                percentageEnded: number;
                started: number;
                ended: number;
                themesWithSessions: { [key: string]: { session: Session; theme: Theme; statistics: { completed: number; skipped: number; unhandled: number } } };
                [key: string]: any;
            } | null,
            default: null,
        },
    },
    data() {
        return {
            selectedThemeId: null as string | null,
            headers: [
                {
                    headerName: 'Temanavn',
                    field: 'title',
                    sortable: true,
                },
                {
                    headerName: 'Tilvalgt',
                    field: 'numberSelectedTheme',
                    sortable: true,
                },
                {
                    headerName: 'Fravalgt',
                    field: 'numberSkippedTheme',
                    sortable: true,
                },
            ],
        };
    },
    computed: {
        ...mapState(useStore, ['courseStatistics', 'themes', 'courses']),
        items() {
            if (!this.$props.selectedCourse || !this.themes || !this.courses) {
                return [];
            }
            const selectedCourseObject = this.courses.find((currentCourse) => {
                return currentCourse.id === this.selectedCourse?.id;
            });
            if (!selectedCourseObject) {
                return [];
            }
            const themesForCourse = this.themes.filter((currentTheme) => {
                return selectedCourseObject.themes.includes(currentTheme.id);
            });

            const statisticEventsForCourse = this.courseStatistics.filter((currentCourseStatistic) => {
                return currentCourseStatistic.ref === selectedCourseObject.id;
            });

            return themesForCourse.map((currentTheme) => {
                const numberOfStatisticEventsWithSkippedCurrentTheme = statisticEventsForCourse.filter((currentStatisticEvent) => {
                    return currentStatisticEvent.skippedThemes?.includes(currentTheme.id);
                });
                return {
                    title: currentTheme.title,
                    numberSelectedTheme: statisticEventsForCourse.length - numberOfStatisticEventsWithSkippedCurrentTheme.length,
                    numberSkippedTheme: numberOfStatisticEventsWithSkippedCurrentTheme.length,
                    id: currentTheme.id,
                };
            });
        },
    },
    methods: {
        onThemeClicked(value: any) {
            this.selectedThemeId = value.id;
            (this.$refs['modal-input'] as HTMLInputElement)?.click();
        },
    },
});
